var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0501 0.499979C5.80844 0.383312 2.33344 3.79165 2.33344 7.99998H0.841773C0.466773 7.99998 0.28344 8.44998 0.550107 8.70831L2.87511 11.0416C3.04177 11.2083 3.30011 11.2083 3.46677 11.0416L5.79177 8.70831C6.05011 8.44998 5.86677 7.99998 5.49177 7.99998H4.00011C4.00011 4.74998 6.65011 2.12498 9.91677 2.16665C13.0168 2.20831 15.6251 4.81665 15.6668 7.91665C15.7084 11.175 13.0834 13.8333 9.83344 13.8333C8.49177 13.8333 7.25011 13.375 6.26677 12.6C5.93344 12.3416 5.46677 12.3666 5.16677 12.6666C4.81677 13.0166 4.84177 13.6083 5.23344 13.9083C6.50011 14.9083 8.09177 15.5 9.83344 15.5C14.0418 15.5 17.4501 12.025 17.3334 7.78331C17.2251 3.87498 13.9584 0.608312 10.0501 0.499979ZM9.62511 4.66665C9.28344 4.66665 9.00011 4.94998 9.00011 5.29165V8.35831C9.00011 8.64998 9.15844 8.92498 9.40844 9.07498L12.0084 10.6166C12.3084 10.7916 12.6918 10.6916 12.8668 10.4C13.0418 10.1 12.9418 9.71665 12.6501 9.54165L10.2501 8.11665V5.28331C10.2501 4.94998 9.96677 4.66665 9.62511 4.66665Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecurrent);
export default __webpack_public_path__ + "static/media/IconRecurrent.d1fd0da6107467b246f6b5758a03f0a2.svg";
export { ForwardRef as ReactComponent };